import { all, call, put, takeLatest } from "redux-saga/effects";
import { getFullNameErrorAction, getFullNameSuccessAction, getTicketByUserIdErrorAction, getTicketByUserIdSuccessAction, getTicketErrorAction, getTicketSuccessAction, registerTicketErrorAction, registerTicketSuccessAction, replyTicketErrorAction, replyTicketSuccessAction } from "../../actions/ticketAction";
import { Types } from "../../types";
import { getTicket, GetTicketResponsesByIdRes, replyTicketRes } from "../../types/ticket/apiRequestTypes";
import { getCustomerFullName, getTicketById, getTicketsByUser, registerTicketBuyUser, replyTicket } from "../apiRequests/tickets";




function* getTicketsByUserHandler(action: any) {
    try {
        const response: { data: getTicket[] } = yield call(getTicketsByUser)
        yield put(
            getTicketSuccessAction({
                params: response.data
            })
        )

    } catch (error: any) {
        yield put(
            getTicketErrorAction({
                error: error.message
            })
        )

    }
}

function* getTicketResponsesByIdHandler(action: any) {
    try {
        const response: { data: GetTicketResponsesByIdRes } = yield call(getTicketById, action.payload)
        yield put(
            getTicketByUserIdSuccessAction({
                params: response.data
            })
        )

    } catch (error: any) {
        yield put(
            getTicketByUserIdErrorAction({
                error: error.message
            })
        )

    }
}

function* registerTicketHandler(action: any) {
    try {
        const response: { data: any } = yield call(registerTicketBuyUser, action.payload)
        yield put(
            registerTicketSuccessAction()
        )

    } catch (error: any) {
        yield put(
            registerTicketErrorAction({
                error: error.message
            })
        )

    }
}
function* replyTicketHandler(action: any) {
    try {
        const response: { data: replyTicketRes } = yield call(replyTicket, action.payload)
        yield put(
            replyTicketSuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            replyTicketErrorAction({
                error: error.message
            })
        )

    }
}

function* getCustomerFullNameHandler(action: any) {
    try {
        const response: { data: string } = yield call(getCustomerFullName)
        yield put(
            getFullNameSuccessAction({
                params: response.data
            })
        )
    } catch (error: any) {
        yield put(
            getFullNameErrorAction({
                error: error.message
            })
        )

    }
}



//********************************************************************************************************************************* */
function* ticketSaga() {
    yield all([takeLatest(Types.GET_TICKET_BY_USER_REQUEST, getTicketsByUserHandler)]);
    yield all([takeLatest(Types.GET_TICKET_BY_USER_ID_TICKET_REQUEST, getTicketResponsesByIdHandler)]);
    yield all([takeLatest(Types.REGISTER_TICKET_REQUEST, registerTicketHandler)]);
    yield all([takeLatest(Types.REPLY_TICKET_REQUEST, replyTicketHandler)]);
    yield all([takeLatest(Types.GET_FULL_NAME_REQUEST, getCustomerFullNameHandler)]);
}

export default ticketSaga